import moment from 'moment';
import { TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { getProductId } from '@/infrastructure/product-info';
import { FieldKey } from '@/proto/field';
import { IGetFieldDistinctDataReq, IGetFieldDistinctDataRsp, MetricType } from '@/proto/metric';
import { toPBTime } from '@raft/utils/src/date';

// 获取下拉APP版本
export const GetFieldDistinctData = async (field: FieldKey, type: MetricType): Promise<string[]> => {
  try {
    const reqBody: IGetFieldDistinctDataReq = {
      productId: getProductId(),
      type,
      name: field,
      startTime: toPBTime(moment()
        .subtract(90, 'days')
        .startOf('day')),
      endTime: toPBTime(moment()),
    };
    const res = await TRPCPost<IGetFieldDistinctDataRsp>(
      `/${API_PREFIX}/trpc/trpc.rmonitor.metrics_server.GetMetrics/GetFieldDistinctData`,
      reqBody,
    );
    return res?.values || [];
  } catch (e) {
    logger.error('GetFieldDistinctData err', e);
    return [];
  }
};
